document.addEventListener('turbolinks:load', () => {
  const quizzes = document.querySelectorAll('.js-quiz-section');
  quizzes.forEach(quiz => {
    initQuiz(quiz);
  });
});

function initQuiz(quiz) {
  const answerOptions = quiz.querySelectorAll('.js-quiz-section-label');
  const checkButtons = quiz.querySelectorAll('.js-quiz-section-button-check');
  const nextButtons = quiz.querySelectorAll('.js-quiz-section-button-next');

  checkButtons.forEach(checkButton => {
    checkButton.addEventListener('click', event => {
      event.preventDefault();
      handleAnswerCheck(event);
    });
  });

  answerOptions.forEach(answerOption => {
    answerOption.addEventListener('click', event => {
      handleAnswerClicked(event);
    });
  });

  nextButtons.forEach(nextButton => {
    nextButton.addEventListener('click', event => {
      event.preventDefault();
      handleNextQuestionClicked(event);
    });
  });
}

function handleAnswerClicked(event) {
  const form = event.target.closest('form');
  const checkButton = form.querySelector('.js-quiz-section-button-check');
  const options = form.querySelectorAll('.js-quiz-section-option');

  options.forEach(option => {
    option.classList.remove('is-selected');
  });

  event.target.closest('.js-quiz-section-option').classList.add('is-selected');
  checkButton.removeAttribute('disabled');
}

function handleAnswerCheck(event) {
  const form = event.target.closest('form');
  const nextButton = form.querySelector('.js-quiz-section-button-next');

  checkAnswers(form);

  // disable current answer options
  form.querySelectorAll('.js-quiz-section-option input').forEach(input => {
    input.disabled = true;
  });

  // replace the check button with the next button
  form
    .querySelector('.js-quiz-section-button-check')
    .classList.add('is-hidden');
  if (nextButton.dataset.lastQuestion === 'false') {
    nextButton.classList.remove('is-hidden');
  }
}

function handleNextQuestionClicked(event) {
  const form = event.target.closest('form');
  const quizSection = form.closest('.js-quiz-section');
  const button = event.target;
  const nextQuestionIndex = button.dataset.nextQuestionIndex;
  const isLastQuestion = button.dataset.lastQuestion === 'true';

  hideAllQuestions(quizSection);
  if (isLastQuestion) {
    return true;
  }

  showNextQuestion(quizSection, nextQuestionIndex);
}

function checkAnswers(form) {
  const selectedOption = form.querySelector(
    '.js-quiz-section-option.is-selected'
  );
  const correctOption = form.querySelector(
    '.js-quiz-section-option[data-is-correct="true"]'
  );

  correctOption.classList.add('quiz-section__option--green');
  if (selectedOption.dataset.isCorrect === 'false') {
    selectedOption.classList.add('quiz-section__option--red');
  }
}

function hideAllQuestions(quizSection) {
  quizSection.querySelectorAll('.js-quiz-section-form').forEach(question => {
    question.classList.add('is-hidden');
  });
}

function showNextQuestion(quizSection, nextQuestionIndex) {
  quizSection
    .querySelector(`.js-quiz-section-form[data-index="${nextQuestionIndex}"]`)
    .classList.toggle('is-hidden');
}
